import {
  Card as MuiCard,
  CardContent as MuiCardContent,
  CircularProgress,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import React, {FunctionComponent, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useAppSelector} from '../../../store/hooks';
import {
  isHasProPlan,
  loadingUser
} from '../../../store/selectors';
import withRedirectAfterLogout from '../../../utils/withRedirectAfterLogout';
import './style.scss';
import styled from 'styled-components';
import UserActions from "./UserActions/UserActions";
import {useNavigate} from "react-router";
import {WhiteCard} from "../../../components/StyledComponents";
import Platform from "../../../models/platforms-data";

const Card = styled(MuiCard)`
  position: relative;
  color: ${(props) => props.theme.palette.primary.main};
`;

const CardContent = styled(MuiCardContent)`
  position: relative;

  &:last-child {
    padding: 0;
    box-sizing: border-box;
  }
`;

const AuditTrail: FunctionComponent = () => {
  const {t: translate} = useTranslation();
  const userLoading = useAppSelector(loadingUser);
  const hasProPlan = useAppSelector(isHasProPlan)
  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState<string>('all')

  useEffect(() => {
    if (!userLoading && !hasProPlan) {
      navigate('/')
    }
  }, [userLoading]);

  return (
    <div id="audit-page">
      <WhiteCard>
      {userLoading ?
        <div className="spinner-wrapper">
          <CircularProgress/>
        </div> :
        <div className="audit-block">
          <div className="audit-block-header">
            <Typography variant="h2" display="block">
              {translate('common.default_pages.audit_trail')}
            </Typography>
            <Select
              value={selectedFilter}
              onChange={(e)=> setSelectedFilter(e.target.value as string)}
              className='audit-filter-select'
              MenuProps={{
                id: 'audit-filter-select-list',
              }}
              >
              <MenuItem value='all'>
                All Actions
              </MenuItem>
              {Object.keys(Platform).map((item) => (
                <MenuItem value={item} key={item}>
                  <img src={Platform[item].smallLogo} alt={Platform[item].title} className='platform-icon'/>
                  {Platform[item].title}
                </MenuItem>
              ))}
            </Select>
          </div>

          <Card>
            <CardContent>
              <UserActions filter={selectedFilter}/>
            </CardContent>
          </Card>
        </div>
      }
      </WhiteCard>
    </div>
  );
};

export default withRedirectAfterLogout()(AuditTrail);
